@use '@design/design-tokens/typography/typography' as *;

.container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.inputContainer {
  border: 1px solid var(--text-disabled);
  background-color: transparent;
  border-radius: 4px;
  padding: 10px 12px;
  height: 40px;

  &.error {
    border-color: var(--border-critical);
  }

  &.focused {
    border-color: var(--border-primary);
  }

  &:not(.focused):hover {
    border-color: var(--border-hover);
  }
}

.errorLabel {
  @include typography-v2-body-sm;

  color: var(--text-critical);
}
